/* global _ */

Wee.fn.make('cart:baseCart', {
	init: function() {
		var priv = this.$private;

		priv.createCart();
		priv.renderQuoteList();
		priv.initEvents();
		priv.updateCart();
		priv.showEmptyCart();
		priv.updateButton();

		// Rerender app on screensize
		Wee.screen.map({
			callback: _.throttle(priv.reRenderApp.bind(priv), 500, {
				trailing: true
			})
		});
	},

	unload: function() {
		$.events.off(false, '.cart');
	}
}, {
	/**
	 * Create cart on page load
	 *
	 * @private
	 */
	createCart: function() {
		var itemCount;

		this.store = Wee.fn.storage();

		itemCount = this.store.get('itemCount');

		if (this.store.get('items') === null) {
			this.store.set('items', []);
			this.store.set('itemCount', 0);
		}

		$('ref:quoteCartNumber').text(itemCount + (itemCount === 1 ? ' item' : ' items'));
	},

	reRenderApp: function() {
		this.app.$resume(true);
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		Wee.events.on({
			'ref:addToQuote': {
				click: function(e, el) {
					scope.addToCart($(el).closest('ref:optionsForm').serialize(true));

					e.preventDefault();
				}
			},

			'ref:currentQuantity': {
				change: function(e, el) {
					if ($(el).val() < 1) {
						swal('Value must be at least 1');

						$(el).val(1);
					} else {
						scope.changeQuantity(e, el);
					}
				},
				click: function(e, el) {
					scope.changeQuantity(e, el);
				}
			},

			'ref:removeItem': {
				click: function(e, el) {
					scope.removeItem(el);
				}
			}
		}, {
			namespace: 'cart'
		});

		$.events.on({
			'ref:cartToggle': {
				click: function() {
					var itemCount = scope.store.get('itemCount');

					if (itemCount > 0) {
						$('ref:miniCart').toggle();
					}
				}
			}
		}, {
			delegate: 'ref:html'
		}, {
			namespace: 'cart'
		});
	},

	/**
	 * Add items to cart
	 *
	 * @private
	 */
	addToCart: function(item) {
		var items = this.store.get('items');

		items.push(item);
		this.store.set('items', items);
		this.updateItemCount();
		Wee.miniCart.$private.updateCartData();
	},

	/**
	 * Update cart item count
	 *
	 * @private
	 */
	updateItemCount: function() {
		var itemCount = this.store.get('itemCount'),
			newCount = itemCount + 1;

		this.store.set('itemCount', newCount);
		this.updateCart();
	},

	/**
	 * Update cart with number of items
	 *
	 * @private
	 */
	updateCart: function() {
		var itemCount = this.store.get('itemCount'),
			$qty = $('ref:cartQty');

		itemCount === 0 ? $qty.disable() : $qty.text(itemCount).enable();
	},

	/**
	 *	Render list of products in quote
	 *
	 * @private
	 */
	renderQuoteList: function() {
		this.app = Wee.app.make('quote-list', {
			target: 'ref:quoteList',
			view: 'quote-list',
			model: this.$public.model()
		});
	},

	/**
	 * Remove item from session storage and data store
	 *
	 * @private
	 */
	removeItem: function(el) {
		var data = this.app.$get(),
			index = $(el).parents('ref:item').data('index'),
			itemCount = this.store.get('itemCount');

		data.items.splice(index, 1);

		this.syncItems(this.app, 'items', data.items);

		this.app.$resume(true);

		this.store.set('itemCount', itemCount - 1);

		this.updateCart();
		this.createCart();
		this.showEmptyCart();
		this.renderQuoteList();
	},

	/**
	 * Show empty quote cart
	 *
	 * @private
	 */
	showEmptyCart: function() {
		if (this.store.get('itemCount') === 0) {
			$('ref:emptyCart').activate();
			$('ref:quoteSummary').disable();
			$('ref:quoteList').disable();
			$('ref:quoteButton').disable();
		}
	},

	/**
	 * Update button text
	 *
	 * @private
	 */
	updateButton: function(discounts) {
		if ($.get('showPricing') && discounts) {
			$('ref:quotePromotions').html('<p class="quote-discounts">You are estimated to save <span class="quote-discounts__span">$' + discounts + '</span></p>');
		}
	},

	/**
	 * Change cart quantity
	 *
	 * @private
	 */
	changeQuantity: function(e, el) {
		var scope = this,
			$el = $(el),
			count = $el.val(),
			app = scope.app,
			index = $el.parents('ref:item').data('index'),
			priceSplit = app.$get('items.' + index + '.productPrice').split(','),
			priceJoin = priceSplit.join(''),
			productPrice = parseFloat(priceJoin);

		scope.syncItems(scope.app, 'items.' + index + '.productQuantity', count);
		scope.syncItems(scope.app, 'items.' + index + '.totalPrice', (count * productPrice));

		scope.app.$set(scope.$public.model());
	}
});
